import { setGamixAppId } from '@/shared/lib/api/client';
import { useAuthStore } from '../hooks/useAuth';

const ACTIVE_APP_STORAGE_KEY = 'corepilot.activeApp';

/* Pre-seed the API client with the workspace id from localStorage so the
 * `gamix-app-id` interceptor has a value on first paint (before the auth store
 * rehydrates). The auth store uses the same key; keeping the read here avoids
 * coupling the shared API client to the feature layer. */
function readStoredActiveAppId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(ACTIVE_APP_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { id?: string };
    return typeof parsed.id === 'string' ? parsed.id : null;
  } catch {
    return null;
  }
}

setGamixAppId(readStoredActiveAppId());

/* Keep the API boundary in sync with runtime workspace switches. The auth store
 * is the single source of truth for the active workspace; this subscription
 * pushes it to the axios interceptor so every generated or raw request carries
 * the header automatically. */
useAuthStore.subscribe((state) => {
  setGamixAppId(state.activeApp?.id ?? null);
});
